// import { orderurl } from '@/utils/baseUrl';
import{post } from '@/utils/request';
import {platurl} from '@/utils/baseUrl';

//获取订单信息
export async function getOrder(params) {
    return post(platurl+'order/getOrderManageList',params,true)
}
export async function getOrderDetails(params) {
    return post(platurl+'order/getOrderDetails',params,true)
}
export async function tiaoJiashenpi(params) {
    return post(platurl+'order/saveOrderChangePriceSq',params,true)
}
export async function jihuoorder(params) {
    return post(platurl+'order/activeOrder',params,true)
}
export async function yctihuoorder(params) {
    return post(platurl+'order/extendOrder',params,true)
}